export const API_PORT = '8080'
export const API_URL = `https://documental-api.dssm.cl/api/`
export const DOMAIN_TITLE = ''